export const FEATURE_FLAGS = {
  VIPPS_PAYMENT_ENABLED: "vipps-payment-method-enabled",
  VIPPS_POPUP_ENABLED: "global_old_vipps_popup",
  VIPPS_POPUP_CLOSEABLE: "global_old_vipps_popup_closable",
  MAINTENANCE: "global_app_maintenance",
  REMOVE_ADDRESSES: "global_remove_addresses",
  CREATE_RECIPE_REMINDER: "global_create_recipe_reminder",
  RECIPE_REJECT: "global_recipe_reject",
  FILTER_NAVIGATION: "global_filter_navigation",
  DIGITAL_RECIPES: "global_digital_recipes_toggle_enabled",
  WISHLIST_RECIPE: "global_wishlist",
  DUMMY_RELEASE: "dummy_release",
  DELIVERY_CALENDAR_REDUCED_CALENDAR:
    "global_delivery_calendar_reduced_calendar",
  WEEK_EDITOR_REDESIGN: "global_week_editor_redesign",
  PRIORITISE_RECOMMENDATIONS_FILTER: "global_prioritise_recommendations_filter",
  WEEK_EDITOR_SORTING: "global_week_editor_sorting",
} as const;
